(function (root) {
  'use strict';

  const swimGroups = [
    ['String Bikini Top', 'String Bikini Bottom', 'String Bikini Set'],
    ['Bandeau Top', 'V-Cut Bikini Bottom', 'Bandeau Bikini Set'],
    ['High-Waisted Bikini Top', 'High-Waisted Bikini Bottom', 'High-Waisted Bikini Set'],
  ];
  const graph = {
    'Sports Bra': ['Leggings', 'Bike Shorts'],
    Leggings: ['Sports Bra', 'Rash Guard Long-Sleeve', 'Rash Guard Short-Sleeve'],
    'Bike Shorts': ['Sports Bra', 'Crop Top', 'Rash Guard Long-Sleeve'],
    'Crop Top': ['Bike Shorts', 'Leggings'],
    'Rash Guard Long-Sleeve': ['Leggings', 'Swim Trunk', 'Swim Shorts', 'Bike Shorts', 'Rash Guard Short-Sleeve'],
    'Rash Guard Short-Sleeve': ['Leggings', 'Swim Trunk', 'Swim Shorts', 'Rash Guard Long-Sleeve'],
    'Swim Trunk': ['Rash Guard Short-Sleeve', 'Rash Guard Long-Sleeve', 'Bath Towel'],
    'Swim Shorts': ['Rash Guard Short-Sleeve', 'Rash Guard Long-Sleeve', 'Bath Towel'],
    'One-Piece Swimsuit': ['Bath Towel', 'Rash Guard Long-Sleeve'],
    'Basketball Jersey': ['Basketball Shorts'],
    'Basketball Shorts': ['Basketball Jersey'],
    'Pullover Hoodie': ['Sweatpants', 'Zip Hoodie', 'Track Jacket'],
    'Zip Hoodie': ['Sweatpants', 'Pullover Hoodie', 'Track Jacket'],
    'Track Jacket': ['Sweatpants', 'Pullover Hoodie', 'Zip Hoodie'],
    Sweatpants: ['Track Jacket', 'Pullover Hoodie', 'Zip Hoodie'],
    'Tech T-Shirt': ['2.5" Inseam Tech Shorts', '7" Lined Performance Shorts', '6.5" Inseam Performance Shorts'],
    '2.5" Inseam Tech Shorts': ['Tech T-Shirt'],
    '7" Lined Performance Shorts': ['Tech T-Shirt'],
    '6.5" Inseam Performance Shorts': ['Tech T-Shirt'],
    'Dog Collar': ['Dog Leash', 'Dog Collar & Leash Set'],
    'Dog Leash': ['Dog Collar', 'Dog Collar & Leash Set'],
    'Dog Collar & Leash Set': ['Dog Collar', 'Dog Leash'],
    'Front Seat Car Mats': ['Back Seat Car Mats', 'Car Mats (Full Set)', 'Windshield Sun Shade'],
    'Back Seat Car Mats': ['Front Seat Car Mats', 'Car Mats (Full Set)', 'Windshield Sun Shade'],
    'Car Mats (Full Set)': ['Front Seat Car Mats', 'Back Seat Car Mats', 'Windshield Sun Shade'],
    'Windshield Sun Shade': ['Car Mats (Full Set)', 'Front Seat Car Mats'],
    'Throw Pillow 18"': ['Sherpa Blanket', 'Arctic Fleece Blanket', 'Throw Pillow 22"'],
    'Throw Pillow 22"': ['Sherpa Blanket', 'Arctic Fleece Blanket', 'Throw Pillow 18"'],
    'Sherpa Blanket': ['Throw Pillow 18"', 'Throw Pillow 22"', 'Arctic Fleece Blanket'],
    'Arctic Fleece Blanket': ['Throw Pillow 18"', 'Throw Pillow 22"', 'Sherpa Blanket'],
    'Desk Mat': ['Mouse Pad'],
    'Mouse Pad': ['Desk Mat'],
    'Carry-On Roller Suitcase': ['Laptop Sleeve', 'Waistpack', 'Crossbody Bag', 'Backpack'],
    Backpack: ['Laptop Sleeve', 'Waistpack', 'Crossbody Bag'],
    'Laptop Sleeve': ['Backpack', 'Carry-On Roller Suitcase'],
    Waistpack: ['Backpack', 'Carry-On Roller Suitcase', 'Crossbody Bag'],
    'Crossbody Bag': ['Backpack', 'Carry-On Roller Suitcase', 'Waistpack'],
    'Duffle Bag Small': ['Laptop Sleeve', 'Waistpack'],
  };
  swimGroups.forEach((group) => group.forEach((role) => {
    graph[role] = [...group.filter((other) => other !== role), 'Rash Guard Long-Sleeve', 'Bath Towel'];
  }));
  const aliases = {
    'Bike Shorts': ['All Over Prints'],
    Panties: ['All Over Prints'],
    Socks: ['All Over Prints'],
    'Back Seat Car Mats': ['Accessories'],
    'EVA Clog': ['Shoes'],
    'Horizontal Tote Bag': ['Bags'],
    'Crop Top': ['Cropped Top'],
    'T-Shirt': ['T-Shirts', 'Lightweight T-Shirt', 'Midweight T-Shirt', 'T-Shirt (96% Cotton)'],
  };
  const norm = (value) => String(value || '').toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9+]+/g, ' ').trim();
  const id = (value) => String(value || '').split('/').pop();
  const text = (product) => `${product.title || ''} ${product.handle || ''}`;

  function role(product) {
    const type = product.type || '';
    if (type === 'All Over Prints') {
      if (/bike[\s-]*shorts/i.test(text(product))) return 'Bike Shorts';
      if (/panties/i.test(text(product))) return 'Panties';
      if (/socks/i.test(text(product))) return 'Socks';
      return '';
    }
    if (type === 'Accessories') return /back[\s-]*seat[\s-]*car[\s-]*mats/i.test(text(product)) ? 'Back Seat Car Mats' : '';
    if (type === 'Shoes') return /eva[\s-]*clogs?/i.test(text(product)) ? 'EVA Clog' : '';
    if (type === 'Bags') return /horizontal[\s-]*tote/i.test(text(product)) ? 'Horizontal Tote Bag' : '';
    if (type === 'Home Decor' || type === 'Paper products') return '';
    if (aliases['T-Shirt'].includes(type)) return 'T-Shirt';
    return type === 'Cropped Top' ? 'Crop Top' : type;
  }

  function device(product) {
    const value = norm(`${product.type || ''} ${product.title || ''}`);
    const iphone = value.match(/\biphone\s+(\d+)\s*(pro\s+max|pro|plus|air|mini)?\b/);
    if (iphone) return `iphone ${iphone[1]} ${iphone[2] || 'base'}`;
    const galaxy = value.match(/\b(?:samsung\s+)?galaxy\s+(s\d+)(?:\s*(ultra|plus|\+|fe))?/);
    if (galaxy) return `galaxy ${galaxy[1]} ${galaxy[2] === '+' ? 'plus' : galaxy[2] || 'base'}`;
    return '';
  }

  function isCase(product) {
    return /\bcase\b/i.test(product.type || '') || /phone[\s-]*case/i.test(text(product));
  }

  function gender(product) {
    let values = Array.isArray(product.gender) ? product.gender : [];
    if (!values.length && Array.isArray(product.taxonomyGender)) values = product.taxonomyGender;
    const declared = values.includes('unisex') || (values.includes('male') && values.includes('female')) ? '' : values.includes('female') ? 'female' : values.includes('male') ? 'male' : '';
    const fromText = (value) => /\b(womens|women|female)\b/.test(norm(value)) ? 'female' : /\b(mens|men|male)\b/.test(norm(value)) ? 'male' : '';
    let explicit = fromText(product.title);
    if (!explicit && ['male', 'female', 'unisex'].includes(product.fit)) explicit = product.fit;
    if (!explicit) explicit = fromText(product.handle);
    if (!explicit && (/bikini|bandeau/.test(norm(role(product))) || ['Sports Bra', 'Bike Shorts', 'Panties', 'Crop Top', 'One-Piece Swimsuit'].includes(role(product)))) explicit = 'female';
    if (explicit === 'unisex') return '';
    if (explicit && declared && explicit !== declared) return 'conflict';
    if (explicit) return explicit;
    const tags = Array.isArray(product.tagGender) ? product.tagGender : [];
    if (declared && tags.length === 1 && tags[0] !== declared) return 'conflict';
    if (declared) return declared;
    return tags.length === 1 ? tags[0] : '';
  }

  function variation(product) {
    return /gr[ae]y[\s-]*dominant/i.test(product.title || '') ? 'gray-dominant' : 'standard';
  }

  function samePrint(source, candidate) {
    return Boolean(source.pattern && candidate.pattern && source.pattern === candidate.pattern && variation(source) === variation(candidate));
  }

  function compatible(source, candidate) {
    if (isCase(source) || isCase(candidate)) return Boolean(isCase(source) && isCase(candidate) && device(source) && device(source) === device(candidate));
    const a = gender(source);
    const b = gender(candidate);
    const apparel = (product) => /bikini|bandeau|swimsuit|swim trunk|swim shorts|rash guard|leggings|shorts|bra|shirt|jersey|hoodie|jacket|sweatpants|crop top|panties|thong|boxer|dress|socks|sneaker|slip-on|clog/i.test(role(product));
    if (apparel(source) && apparel(candidate) && (a === 'conflict' || b === 'conflict' || (a && b && a !== b))) return false;
    const agesA = (Array.isArray(source.age) ? source.age : []).map(norm);
    const agesB = (Array.isArray(candidate.age) ? candidate.age : []).map(norm);
    if (agesA.length && agesB.length && !agesA.some((age) => agesB.includes(age))) return false;
    return true;
  }

  function candidateTypes(source) {
    if (source.giftCard || !role(source)) return [];
    const roles = [role(source), ...(graph[role(source)] || [])];
    const types = new Set([source.type, ...roles.flatMap((value) => [value, ...(aliases[value] || [])])]);
    if (isCase(source)) {
      types.add('Phone Case');
      const d = device(source);
      if (d.startsWith('iphone ')) types.add(`iPhone ${d.replace('iphone ', '').replace(' base', '').replace(/\b\w/g, (c) => c.toUpperCase())} Case`);
      if (d.startsWith('galaxy ')) types.add(`Samsung Galaxy ${d.replace('galaxy ', '').replace(' base', '').replace(/\b\w/g, (c) => c.toUpperCase())} Case`);
    }
    return [...types].filter(Boolean).sort();
  }

  function rank(source, candidates, providerIds = [], limit = 10) {
    if (source.giftCard || !role(source)) return [];
    const sourceRole = role(source);
    const related = graph[sourceRole] || [];
    const swim = swimGroups.find((group) => group.includes(sourceRole));
    const manual = [...(source.complementary || []), ...(source.related || [])].map(id);
    const provider = providerIds.map(id);
    const seen = new Set([id(source.id)]);
    return candidates.filter((candidate) => {
      const key = id(candidate.id);
      if (!key || seen.has(key) || !candidate.available || candidate.giftCard || !compatible(source, candidate)) return false;
      seen.add(key);
      return true;
    }).map((candidate) => {
      const candidateRole = role(candidate);
      const print = samePrint(source, candidate);
      let score = 0;
      if (swim?.includes(candidateRole) && sourceRole !== candidateRole && print) score = 1000 - swim.filter((value) => value !== sourceRole).indexOf(candidateRole) * 10;
      else if (print && related.includes(candidateRole)) score = 700 - related.indexOf(candidateRole) * 10;
      else if (candidateRole === sourceRole || (isCase(source) && isCase(candidate))) score = print ? 500 : 300;
      if (!score) return null;
      const manualIndex = manual.indexOf(id(candidate.id));
      const providerIndex = provider.indexOf(id(candidate.id));
      return { ...candidate, score, manualRank: manualIndex < 0 ? 1000 : manualIndex, providerRank: providerIndex < 0 ? 1000 : providerIndex };
    }).filter(Boolean).sort((a, b) => b.score - a.score || a.manualRank - b.manualRank || a.providerRank - b.providerRank || String(a.handle).localeCompare(String(b.handle)) || id(a.id).localeCompare(id(b.id))).slice(0, Math.min(10, Math.max(0, limit)));
  }

  const escapeQuery = (value) => String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  const queryForTypes = (types) => types.map((type) => `product_type:"${escapeQuery(type)}"`).join(' OR ');
  const api = { role, device, gender, variation, samePrint, compatible, candidateTypes, rank, queryForTypes };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.ConcealRelatedRules = api;
  if (!root.document || !root.customElements || root.customElements.get('conceal-related-products')) return;

  const requests = new Map();
  async function request(url, { timeoutMs = 10000, attempts = 2 } = {}) {
    if (!requests.has(url)) {
      const promise = (async () => {
        for (let attempt = 0; attempt < attempts; attempt += 1) {
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), timeoutMs);
          try {
            const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
            if (!response.ok) throw new Error(`Related products: HTTP ${response.status}`);
            return await response.text();
          } catch (error) {
            if (attempt === attempts - 1) throw error;
            await new Promise((resolve) => setTimeout(resolve, 250));
          } finally {
            clearTimeout(timeout);
          }
        }
      })();
      requests.set(url, promise);
      promise.catch(() => requests.delete(url));
    }
    return requests.get(url);
  }

  function searchUrl(base, query, sectionId, page = 1) {
    const url = new URL(base, root.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('sort_by', 'relevance');
    url.searchParams.set('options[prefix]', 'none');
    url.searchParams.set('options[unavailable_products]', 'show');
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', page);
    return url.href;
  }

  async function candidatesFor(base, types) {
    const all = [];
    let nextType = 0;
    async function worker() {
      while (nextType < types.length) {
        const type = types[nextType++];
        let page = 1;
        let expectedTotal;
        const products = [];
        do {
          const url = new URL(`${base.replace(/\/$/, '')}/types`, root.location.origin);
          url.searchParams.set('q', type);
          url.searchParams.set('sort_by', 'title-ascending');
          url.searchParams.set('section_id', 'conceal-related-data');
          url.searchParams.set('page', page);
          const html = new DOMParser().parseFromString(await request(url.href), 'text/html');
          const node = html.querySelector('[data-related-candidates]');
          if (!node) throw new Error('Related products: candidate data missing');
          const data = JSON.parse(node.textContent);
          if (data.page !== page || !Array.isArray(data.products)) throw new Error('Related products: invalid pagination');
          if (data.total > 1000 || (expectedTotal !== undefined && data.total !== expectedTotal)) throw new Error('Related products: incomplete type collection');
          expectedTotal = data.total;
          products.push(...data.products);
          if (!data.nextPage) break;
          if (data.nextPage !== page + 1 || page >= 20) throw new Error('Related products: invalid next page');
          page = data.nextPage;
        } while (true);
        if (new Set(products.map((product) => id(product.id))).size !== expectedTotal) throw new Error('Related products: incomplete collection pages');
        all.push(...products.filter((product) => product.type === type));
      }
    }
    await Promise.all(Array.from({ length: Math.min(4, types.length) }, worker));
    return all;
  }

  class ConcealRelatedProducts extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      const config = this.querySelector('[data-related-source]');
      if (!config) return;
      this.source = JSON.parse(config.textContent);
      if (!candidateTypes(this.source).length) return;
      if (!('IntersectionObserver' in root)) return void this.load();
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.load();
      }, { rootMargin: '0px 0px 600px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      if (this.started) return;
      this.started = true;
      try {
        const providerUrl = new URL(this.dataset.recommendationsUrl, root.location.origin);
        providerUrl.searchParams.set('product_id', id(this.source.id));
        providerUrl.searchParams.set('limit', '10');
        providerUrl.searchParams.set('intent', 'related');
        const providerPromise = request(providerUrl.href, { timeoutMs: 1200, attempts: 1 }).then((value) => JSON.parse(value).products.map((product) => product.id)).catch(() => []);
        const candidates = await candidatesFor(this.dataset.collectionsUrl, candidateTypes(this.source));
        const ordered = rank(this.source, candidates, await providerPromise, Number(this.dataset.limit));
        if (!ordered.length || !this.isConnected) return;
        const query = ordered.map((product) => `title:"${escapeQuery(product.title)}"`).join(' OR ');
        const cards = new Map();
        let page = 1;
        do {
          const response = await request(searchUrl(this.dataset.searchUrl, query, this.dataset.sectionId, page));
          const html = new DOMParser().parseFromString(response, 'text/html');
          html.querySelectorAll('[data-related-card]').forEach((card) => cards.set(card.dataset.relatedCard, card));
          const pagination = html.querySelector('[data-related-card-pagination]');
          if (!pagination) throw new Error('Related products: card pagination missing');
          const data = JSON.parse(pagination.textContent);
          if (data.page !== page) throw new Error('Related products: invalid card page');
          if (!data.nextPage || ordered.every((product) => cards.has(id(product.id)))) break;
          if (data.nextPage !== page + 1 || page >= 20) throw new Error('Related products: invalid card pagination');
          page = data.nextPage;
        } while (true);
        const missing = ordered.filter((product) => !cards.has(id(product.id)));
        for (let offset = 0; offset < missing.length; offset += 4) {
          await Promise.all(missing.slice(offset, offset + 4).map(async (product) => {
            if (!product.url) return;
            const url = new URL(product.url, root.location.origin);
            if (url.origin !== root.location.origin) return;
            url.search = '';
            url.searchParams.set('section_id', this.dataset.sectionId);
            try {
              const html = new DOMParser().parseFromString(await request(url.href), 'text/html');
              const template = html.querySelector('template[data-related-single-card]');
              const card = template?.content.querySelector('[data-related-card]');
              if (card?.dataset.relatedCard === id(product.id)) cards.set(id(product.id), card);
            } catch (_) {}
          }));
        }
        const grid = this.querySelector('[data-related-grid]');
        for (const product of ordered) {
          const card = cards.get(id(product.id));
          if (card) grid.appendChild(card.cloneNode(true));
        }
        if (!this.isConnected || !grid.children.length) return;
        this.querySelector('[data-related-content]').hidden = false;
        this.classList.add('product-recommendations--loaded');
        this.dataset.loaded = 'true';
      } catch (error) {
        this.dataset.loadError = 'true';
        console.warn(error.message);
      }
    }
  }
  root.customElements.define('conceal-related-products', ConcealRelatedProducts);
})(typeof window === 'undefined' ? globalThis : window);
